import store from "../store/index";

const botId = localStorage.getItem("botId");

const accessToken = localStorage.getItem("accessToken");

// Example of a shared function for general interceptors
export function setupBaseInterceptors(axiosInstance) {
  // REQUEST interceptor
  axiosInstance.interceptors.request.use(
    (config) => {
      store.dispatch("setLoader", true);
      if (botId && config) {
        config.headers[
          "access-key"
        ] = `${accessToken},${botId},${localStorage.getItem("currentRoute")}`;
      }
      const userToken = localStorage.getItem("userToken");

      if (!config.headers.Authorization) {
        if (userToken) {
          config.headers.Authorization = `Bearer ${userToken}`;
        }
      }
      return config;
    },
    (error) => {
      store.dispatch("setLoader", false);
      return Promise.reject(error);
    }
  );

  // RESPONSE interceptor
  axiosInstance.interceptors.response.use(
    (response) => {
      store.dispatch("setLoader", false);
      checkAccess(response);

      return response;
    },
    (error) => {
      store.dispatch("setLoader", false);
      return Promise.reject(error);
    }
  );
}

function checkAccess(response) {
  if (
    response.headers["can-access"] &&
    response.headers["can-access"] === "false"
  ) {
    store.dispatch("setSnackbar", {
      text: `Warning , another user editing on the same page`,
      color: "error",
    });
  }
}
